<script>
    import SecurityItem from './SecurityItem.svelte'

    import { Container } from '@/components'

    const items = [
        {
            title: 'Безопасность',
            description: 'Надёжно храним всю информацию, к которой<br/> получаем доступ. Страхуем ответственность<br/> и компенсируем ошибки',
            icon: 'safety',
            corner: 'right-top'
        },
        {
            title: 'Экспертиза',
            description: 'За 25 лет накопили знания, опыт<br/> и завоевали доверие более 700<br/> международных и российских клиентов',
            icon: 'expert',
            corner: 'left-bottom'
        },
        {
            title: 'Гибкость и поддержка',
            description: 'Готовы подстроиться под ваши сроки<br/> и быстро запустить проект. Всегда на связи:<br/> не уходим в отпуск и не болеем',
            icon: 'chat',
            corner: 'left-top'
        },
        {
            title: 'Качество',
            description: 'Регулярно проходим внешний и внутренний<br/> аудит в соответствии с международным<br/> требованиям ведения бизнеса',
            icon: 'medal',
            corner: 'right-bottom'
        }
    ]
</script>

<Container>
    <h2 class="title">Гарантируем безопасность данных,<br/> качество и удобную работу</h2>

    <div class="description">
        EmployeeGate разработали специалисты аутсорсинговой компании UCMS Group. Входим в ТОП-2 крупнейших<br/>
        компаний в области расчёта заработной платы, в ТОП-5 — кадрового делопроизводства, в ТОП-6 — общего рейтинга<br/>
        компаний в области аутсорсинга учётных функций по итогам деятельности за 2020 год <span>«Эксперт РА»</span>
    </div>
    
    <div class="wrapper">
        {#each items as data }
            <div class="security-item-wrapper">
                <SecurityItem {data} />
            </div>
        {/each}
    </div>

    <div class="welcome">Узнайте больше о нас на сайте <a class="link" href="https://www.ucmsgroup.ru">www.ucmsgroup.ru</a></div>
</Container>

<style lang="scss">
    .title {
        line-height: 60px;
        text-align: center;
    }

    .description {
        margin-top: 40px;
        font-size: 20px;
        line-height: 25px;
        text-align: center;

        span {
            color: #c7c7c7;
        }
    }

    .wrapper {
        margin-top: 80px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        > div {
          &:first-of-type {
              margin-right: 30px;
              margin-bottom: 30px;
          }
          
          &:last-of-type {
              margin-left: 30px;
          }
        }
    }

    .welcome {
        margin-top: 40px;
        text-align: center;
    }

    @media (max-width: 834px) {
        .title,
        .description {
            br {
                display: none;
            }
        }

        .security-item-wrapper {
            width: calc(100% / 2 - 20px);
            margin: 0;
            margin-bottom: 20px;
        }
    }

    @media (max-width: 420px) {
        .description {
            font-size: 14px;
            line-height: 18px;
            padding: 0 10px;
        }

        .wrapper {
            display: block;

            .security-item-wrapper {
                width: 100%;
                margin: 0 0 30px 0 !important;
            }
        }
    }
</style>